import React, { useRef, useState } from 'react';
import {
  useFloating,
  autoUpdate,
  FloatingArrow,
  arrow,
  offset,
  autoPlacement,
  useHover,
  useFocus,
  useInteractions,
  safePolygon,
} from '@floating-ui/react';
import { AnimatePresence, motion } from 'framer-motion';

export function useTooltip() {
  const [isOpen, setIsOpen] = useState(false);
  const arrowRef = useRef(null);

  const { refs, context, floatingStyles } = useFloating({
    placement: 'top',
    whileElementsMounted: autoUpdate,
    open: isOpen,
    onOpenChange: setIsOpen,
    middleware: [
      offset(8),
      arrow({ element: arrowRef }),
      autoPlacement({ allowedPlacements: ['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end'] }),
    ]
  });

  return {
    arrowRef,
    context,
    refs,
    floatingStyles,
    isOpen,
    ...useInteractions([
      useHover(context, {
        handleClose: safePolygon(),
        restMs: 25,
        delay: { open: 100 },
      })
    ]),
  }
}

export function Tooltip({ arrowRef, context, getFloatingProps, floatingStyles, isOpen, refs, children }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div initial={{ top: 3, opacity: 0 }} animate={{ top: 0, opacity: 1 }} exit={{ top: 3, opacity: 0 }} ref={refs.setFloating} {...getFloatingProps()} style={floatingStyles} className="rounded px-2 py-1 bg-stone-800 text-white text-sm backdrop-blur max-w-[180px] md:max-w-96 text-xs z-[100] whitespace-normal">
          {children}
          <FloatingArrow ref={arrowRef} context={context} fill="#292524" tipRadius={2} />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
